import { styled, keyframes } from 'styled-components';
export const Wrapper = styled.div `
  display: flex;
  height: 100vh;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;
export const Error = styled.p `
  margin: 15px 0 0 0;
  width: 730px;
  text-align: center;
  max-width: calc(100% - 30px);
`;
export const Loader = styled.div `
  width: 200px;
  height: 200px;
  transform-style: preserve-3d;
  perspective: 2000px;
  transform: rotateX(-30deg) rotateY(-45deg);
`;
export const Element = styled.div `
  position: absolute;
  top: 50%;
  left: 50%;
  transform-style: preserve-3d;
  &:nth-child(1) {
    transform: rotateZ(-90deg) rotateX(-90deg) translate3d(0, 3em, calc(3em * 0.5));
  }
  &:nth-child(2) {
    transform: translate3d(0em, 3em, calc(3em * 0.5));
  }
  &:nth-child(3) {
    transform: rotateY(-90deg) rotateX(90deg) translate3d(0, 3em, calc(3em * 0.5));
  }
`;
const boxAnimation = keyframes `
  8.33%{
    transform: translate3d(-50%,-50%,0) scaleZ(2);
  }
  16.7%{
    transform: translate3d(-50%,-50%,-3em) scaleZ(1);
  }
  25%{
    transform: translate3d(-50%,-100%,-3em) scaleY(2);
  }
  33.3%{
    transform: translate3d(-50%,-150%,-3em) scaleY(1);
  }
  41.7%{
    transform: translate3d(-100%,-150%,-3em) scaleX(2);
  }
  50%{
    transform: translate3d(-150%,-150%,-3em) scaleX(1);
  }
  58.3%{
    transform: translate3d(-150%,-150%, 0) scaleZ(2);
  }
  66.7%{
  transform: translate3d(-150%,-150%,0) scaleZ(1);
  }
  75%{
    transform: translate3d(-150%,-100%,0) scaleY(2);
  }
  83.3%{
    transform: translate3d(-150%,-50%,0) scaleY(1);
  }
  91.7%{
    transform: translate3d(-100%,-50%,0) scaleX(2);
  }
  100%{
    transform: translate3d(-50%,-50%,0) scaleX(1);
  }
`;
export const SubElement = styled.div `
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  transform-style: preserve-3d;
  animation: ${boxAnimation} 6s infinite;
  width: 3em;
  height: 3em;
  opacity: 0.9;
  border-radius: 4px;
  background-color: ${({ $color }) => $color};

  &:before,
  &:after {
    position: absolute;
    width: 100%;
    height: 100%;
    content: '';
    border: 0.5px solid;
    border-radius: 4px;
    background-color: ${({ $color }) => $color};
  }
  &:before {
    left: 100%;
    bottom: 0;
    transform: rotateY(90deg);
    transform-origin: 0 50%;
  }
  &:after {
    left: 0;
    bottom: 100%;
    transform: rotateX(90deg);
    transform-origin: 0 100%;
  }
`;
